export default __webpack_public_path__ + "static/media/christmasLogo.6850a9ca.png";